// extracted by mini-css-extract-plugin
export default {"img":"ProductModal1_img__agEF-","info":"ProductModal1_info__c-Q+8","color_box":"ProductModal1_color_box__0uaco","button_box":"ProductModal1_button_box__8yZfN"};